import styled from '@emotion/styled';

import { overflowHyphens } from '@hrworks/design-system/utilities';

import { mq } from '../../util/mediaQueries';

const Container = styled.div(({ theme }) => ({
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  paddingBlock: theme.eclipseTier1.spacing['32px'],
}));

const Content = styled.div(({ theme }) => [
  overflowHyphens,
  {
    maxWidth: 'min(90%, 870px)',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.eclipseTier1.spacing['12px'],
  },
]);

const typoBaseStyle = {
  margin: 0,
  padding: 0,
};

const Title = styled.h1(({ theme }) => [
  typoBaseStyle,
  {
    ...theme.eclipseTier2Typography.display,
    [mq['<=xs']]: {
      ...theme.eclipseTier2Typography.headingMd,
    },
  },
]);

const SubTitle = styled.div(({ theme }) => [
  typoBaseStyle,
  {
    ...theme.eclipseTier2Typography.headingMdSemibold,
    [mq['<=xs']]: {
      ...theme.eclipseTier2Typography.bodyMd,
    },
  },
]);

const ButtonWrapper = styled.div(({ theme }) => ({
  marginTop: theme.eclipseTier1.spacing['12px'],
}));

export const S = {
  Container,
  Content,
  Title,
  SubTitle,
  ButtonWrapper,
} as const;
